<template>
    <div class="gray-back" style="padding:.2rem 0 8rem 0">
        <div class="danwei-warp">
            <div class="title">{{row.danwei}}</div>
            <div class="saiqu">{{row.datetitle}} {{row.province}}{{row.city}}</div>
            <div class="duiwu" v-if="row.member_list.length>0">
                <span v-for="(member,mkey)  in row.member_list" v-if="mkey<4" :key="mkey">{{member.name}} </span>
                等{{row.members}}人报名
            </div>
            <div class="duiwu" v-else>
                暂无人员报名
            </div>
        </div>

        <div class="step-warp">
            <van-steps direction="vertical"  active-color="#00B388" :active="active">
                <van-step>
                    <div class="step-li">
                        <div class="title">考试信息</div>
                        <p class="desc">考级批次信息</p>
                        <div class="right tiny-btn-0" @click="action(1)" v-if="row.status!=2">修改信息</div>
                    </div>
                </van-step>
                <van-step>
                    <div class="step-li">
                        <div class="title">人员信息</div>
                        <p class="desc">运动员考级报名管理</p>
                        <div class="right tiny-btn-0" @click="action(2)" v-if="row.status!=2">人员管理</div>
                        <div class="right tiny-btn-1" @click="action(3)" v-if="row.status!=2">邀请卡管理</div>
                    </div>
                </van-step>
                <van-step>
                    <div class="step-li">
                        <div class="title">确认订单并支付</div>
                        <p class="desc">确认订单支付费用</p>
                        <div  v-if="row.member_list.length>0 && row.status!=2" class="right tiny-btn-0" @click="action(4)" >支付费用</div>
                    </div>
                </van-step>
                <van-step>
                    <div class="step-li">
                        <div class="title">报名成功</div>
                        <p class="desc">报名成功</p>
                    </div>
                </van-step>
            </van-steps>
        </div>
    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }
    .tiny-btn-1{
        top:30px !important;
    }

    .step-warp{
        margin: 0.2rem;
        border-radius:0.2rem;
        padding: 0.2rem;
        background: #fff;
    }
    .step-warp .step-li{
        color: #000;
        position: relative;
    }
    .step-warp .step-li .title{
        font-size: 14px;
    }
    .step-warp .step-li .desc{
        margin-top: 0.2rem;
        font-size: 12px;
        color: #666;
    }
    .step-warp .right{
        position: absolute;
        top:0;
        right: 0;
    }
    .danwei-warp{
        margin: 0.2rem;
        background: #fff;
        box-shadow:0px 0px 10px 0px rgba(204,204,204,0.5);
        border-radius:0.2rem;
        padding: 0.2rem;
    }
    .danwei-warp .title{
        font-size: 18px;
        color: #000;
        margin: 0.4rem 0.2rem 0.2rem 0.2rem;
        font-weight: bold;
    }
    .danwei-warp .saiqu{
        font-size: 14px;
        margin: 0rem 0.2rem 0.4rem 0.2rem;
        color: #666;
    }
    .danwei-warp .duiwu{
        font-size: 12px;
        margin: 0.4rem 0.2rem 0rem 0.2rem;
        color: #999;
    }
    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';

    import {Cell,Field,Area,Form,Divider,Steps,Step, CellGroup,RadioGroup,Radio,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import JiaolianPicker from '@/components/picker/JiaolianPicker.vue';

    Vue.use(Cell).use(CellGroup).use(Steps).use(Step).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyDetail',
        components: {
            [Field.name]: Field,
            PicUploader,
            CaipanPicker,
            JiaolianPicker,
        },
        data: function () {
            return {
                validator,
                saveLoading:false,
                saiqu_id: this.$route.query.saiqu_id,
                showCaipanPicker:false,
                showJiaolianPicker:false,
                showNumTypePicker:false,
                numTypeColumns: ['身份证', '护照'],
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                row: {
                    id:0,
                    saiqu_name:'',
                    numTypeName:'身份证',
                    danwei:'',
                    memberstatus:0,
                    ldcardtype:1,
                    ldsex:1,
                    member_list:[],
                    saiqu:{

                    },
                    heying:[{name:"选择商户.png",
                        save_name:"h5/2020-05-11/1589187988243621.png",
                        uid:"vc-upload-1589187988243621",
                        url:"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-05-11/1589187988243621.png"
                    }],
                    caipan:[],
                    jiaolian:[],
                },
            }
        },
        filters: {},
        computed:{
            active(){
                switch (this.row.status){
                    case 1:
                        return 2;
                    break;
                    case 2:
                        return 4;
                    break;
                    default:
                        return 1;
                }
            }
        },
        mounted() {
            let that = this;
            that.areaList = area;
            that.row.id = this.$route.query.id;
            this.fetch();

            window.rbMessage = function (data) {
                if(data == 'saiApplyDetailReload'){
//                    alert('that.fetch()')
                    that.fetch();
                }
            }
        },
        watch: {
        },
        destroyed() {
        },
        methods: {
            fetch(){
                let that = this;
                that.$api.get('/api/qcxj/applyDetail', {
                    id : that.row.id,
                }, (res) => {
                    that.row =   res.data;
                })
            },
            action(type){
                switch (type){
                    case 1 :
                        rbLink({
                            name:'ExameApplyFormBasic',query:{id:this.row.id}
                        });
                        break;

                    case 2:
                        rbLink({
                            name:'ExameApplyMemberList',query:{kaoji_id:this.row.id}
                        });
                        break;

                    case 3:
                        rbLink({
                            name:'ExameApplyShareList',query:{kaoji_id:this.row.id}
                        });
                        break;
                    case 4:
                        rbLink({
                            name:'ExameApplyOrder',query:{id:this.row.id}
                        });
                        break;
                }
            },
            onQuestion(){
                console.log('onQuestion')
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },

        }
    }
</script>



// WEBPACK FOOTER //
// ExameApplyDetail.vue?66d37027